import { getBootstrapData } from '@experience/core-hostapp-share-lib';

import { client } from './generated/api/client.gen';

export { client } from './generated/api/client.gen';

/**
 * Базовый URL API. Никогда не берём значение из runtime-конфигурации, всегда берётся текущий
 * домен, если нужно использовать другой домен — его нужно прописать явно в `.env.production`.
 */
export const getApiBaseUrl = (): string => {
  const apiUrl = import.meta.env.VITE_API_URL as string | undefined;

  return apiUrl ?? '';
};

/**
 * Конфигурирует общий клиент API, сгенерированный openapi-ts.
 */
export const initApiClient = () => {
  const { userId, isUnderImpersonalization } = getBootstrapData();
  const apiUrl = getApiBaseUrl();
  const config = client.getConfig();
  let baseUrl = config.baseUrl;

  if (apiUrl && config.baseUrl !== apiUrl) {
    baseUrl = apiUrl;
  } else if (!apiUrl) {
    baseUrl = '';
  }

  const newHeaders: Record<string, string> = {};

  if (userId !== null && isUnderImpersonalization) {
    newHeaders['Impersonate'] = String(userId);
  }

  client.setConfig({ baseUrl, headers: newHeaders });

  return client;
};
